import { APP_ROLE } from '@/config/env'
import {
  startClientRealtime,
  stopClientRealtime,
} from '@/features/client-orders/realtime/clientRealtime'
import {
  startCourierRealtime,
  stopCourierRealtime,
} from '@/features/courier-orders/realtime/courierRealtime'
import {
  startRestaurantRealtime,
  stopRestaurantRealtime,
} from '@/features/restaurant-orders/realtime/restaurantRealtime'
import { disconnectSocket } from '@/shared/socket/socketClient'
import { useAuthStore } from '@/stores/auth'

export async function bootstrapRealtime() {
  const authStore = useAuthStore()
  if (!authStore.isLoggedIn) {
    return
  }

  if (APP_ROLE === 'restaurant') {
    await startRestaurantRealtime()
  }

  if (APP_ROLE === 'courier') {
    await startCourierRealtime()
  }

  if (APP_ROLE === 'client') {
    await startClientRealtime()
  }
}

export function teardownRealtime() {
  if (APP_ROLE === 'restaurant') {
    stopRestaurantRealtime()
  }
  if (APP_ROLE === 'courier') {
    stopCourierRealtime()
  }
  if (APP_ROLE === 'client') {
    stopClientRealtime()
  }
  disconnectSocket()
}
